/* Mobile: iOS blocks silent autoplay (esp. Low Power Mode). Show the poster
   with a Tap-to-play overlay; hide it once the video is actually playing. */
(function () {
  var fig = document.querySelector('.cc-video-fig');
  if (!fig) return;
  var v = fig.querySelector('video');
  var btn = fig.querySelector('.cc-video-tap');
  if (!v) return;
  v.muted = true;
  v.setAttribute('muted', '');
  v.setAttribute('playsinline', '');
  v.setAttribute('webkit-playsinline', '');

  function hideBtn() { if (btn) btn.classList.add('cc-is-hidden'); }
  function showBtn() { if (btn) btn.classList.remove('cc-is-hidden'); }
  function play() {
    v.muted = true;
    var p = v.play();
    if (p && p.then) p.then(hideBtn).catch(showBtn);
  }

  v.addEventListener('playing', hideBtn);
  v.addEventListener('pause', showBtn);
  v.addEventListener('error', showBtn);

  // Tap the button OR the video itself toggles playback — runs inside the
  // user gesture so iOS in-app browsers (WKWebView) allow it.
  if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); play(); });
  v.addEventListener('click', function () { if (v.paused) play(); else v.pause(); });

  var coarse = window.matchMedia('(hover: none)').matches || ('ontouchstart' in window);
  if (!coarse) {
    // Desktop: muted autoplay. Attempt immediately and again once it can
    // play / scrolls into view, so a missed event can't leave it paused.
    play();
    v.addEventListener('loadeddata', play, { once: true });
    v.addEventListener('canplay', play, { once: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) play(); });
      }, { threshold: 0.25 }).observe(v);
    }
  } else {
    // Touch devices: never auto-attempt (it blanks the poster to black on
    // iOS). Show the poster + Tap-to-play and wait for a real tap.
    showBtn();
  }
})();
